// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyA7ethohA0z6YAjgH7ltrMkigLfTb-jtOs",
  authDomain: "restaurant-426210.firebaseapp.com",
  projectId: "restaurant-426210",
  storageBucket: "restaurant-426210.appspot.com",
  messagingSenderId: "693842652315",
  appId: "1:693842652315:web:ed8bf2e7c43856a08caa3e",
  measurementId: "G-WHYCR4KVWQ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { auth, db, storage };
